import React from "react";
import { BadgePercent } from "lucide-react";
import { useStorefront } from "@/hooks/useStorefront";

export default function OnlinePayBanner({ testid }) {
    const { settings } = useStorefront();
    const amount = Number(settings?.online_payment_discount || 0);
    if (!settings?.online_payment_enabled || amount <= 0) return null;
    return (
        <div
            data-testid={testid}
            className="flex items-center gap-3 bg-gold-500/15 border border-gold-500/50 rounded-xl px-4 py-3"
        >
            <BadgePercent className="w-5 h-5 text-forest-800 shrink-0" />
            <p className="font-serif font-bold text-forest-800 text-sm sm:text-base leading-snug">
                Pay {amount.toLocaleString()} PKR less if you pay online
                <span className="block font-sans font-medium text-[11px] sm:text-xs text-forest-700/80">
                    Easypaisa · JazzCash · Bank Transfer
                </span>
            </p>
        </div>
    );
}
